import React from 'react'
import { ButtonLink, PriceLockup, Box, Callout } from '@telus-uds/components-web'
import ButtonLinkWrapper, { ButtonLinkWrapperProps } from '../ButtonLinkWrapper/ButtonLinkWrapper'
import { LegalTextRenderer } from '../../../utils/text/TextRenderer'

import {
  StickyNav,
  StickyNavInfoContainer,
  StickyNavInfo,
  NavCallout,
  StickyNavRibbon,
  XlNav,
  ButtonPadding,
} from './Styles'

export type StickyCartNavProps = {
  stickyNavRibbon?: string
  stickyNavRibbonWithCoupon?: string
  stickyNavCallout?: string
  stickyNavPrice?: string
  stickyNavCouponPrice?: string
  stickyNavPriceSize?: string
  stickyNavPriceRateText?: string
  stickyNavButtonHref?: string
  stickyNavCouponButtonHref?: string
  stickyNavButtonText?: string
  customButtonLinkNavProps?: ButtonLinkWrapperProps | undefined
  visible?: boolean
  cartActive?: boolean
}

const StickyCartNav = ({
  stickyNavRibbon,
  stickyNavRibbonWithCoupon,
  stickyNavCallout,
  stickyNavPrice,
  stickyNavCouponPrice,
  stickyNavPriceSize = 'medium',
  stickyNavPriceRateText = '/month',
  stickyNavButtonHref,
  stickyNavCouponButtonHref,
  stickyNavButtonText,
  customButtonLinkNavProps,
  visible,
  cartActive,
}: StickyCartNavProps) => {
  let price = ''
  if (cartActive && stickyNavCouponPrice) {
    price = stickyNavCouponPrice
  } else if (stickyNavPrice) {
    price = stickyNavPrice
  }
  return (
    <StickyNav visible={visible} data-testid={'stickyCartNav-testid'}>
      <XlNav>
        <StickyNavInfoContainer>
          <Box>
            <StickyNavInfo>
              <StickyNavRibbon>
                <LegalTextRenderer>
                  {typeof stickyNavRibbonWithCoupon !== 'undefined' && cartActive
                    ? stickyNavRibbonWithCoupon
                    : stickyNavRibbon}
                </LegalTextRenderer>
              </StickyNavRibbon>
              {stickyNavCallout && (
                <NavCallout>
                  <Callout variant={{ rounded: true }}>
                    <LegalTextRenderer>{stickyNavCallout}</LegalTextRenderer>
                  </Callout>
                </NavCallout>
              )}
            </StickyNavInfo>
          </Box>
          <PriceLockup
            data-testid={'stickyNav-pricelockUp'}
            price={price}
            size={stickyNavPriceSize}
            rateText={stickyNavPriceRateText}
          />
        </StickyNavInfoContainer>
        <ButtonPadding style={{ paddingBottom: 5 }}>
          {customButtonLinkNavProps ? (
            <ButtonLinkWrapper
              {...customButtonLinkNavProps}
              buttonLinkProps={{
                ...customButtonLinkNavProps.buttonLinkProps,
                url: cartActive ? stickyNavCouponButtonHref ?? '' : stickyNavButtonHref ?? '',
              }}
            />
          ) : (
            <ButtonLink
              href={cartActive ? stickyNavCouponButtonHref : stickyNavButtonHref}
              variant={{ priority: 'high', width: 'full' }}
              tokens={{
                paddingBottom: 8,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 8,
              }}
            >
              {stickyNavButtonText}
            </ButtonLink>
          )}
        </ButtonPadding>
      </XlNav>
    </StickyNav>
  )
}

export default StickyCartNav
